<template>
  <div class="fill-height">
    <v-row v-if="artists && artists.length" class="fill-height artists-holder" align="center" justify="center">
      <!-- <ClipPageMask :data-reveal="loaded" :data-transition="transitionComplete"> -->
        <MomentumScrolling :content-classes="{'scrolling-content': true, 'paper-background': true, 'py-16': true}" @scroll="scroll = $event">
          <v-row class="fill-height" align="center" justify="center">
            <v-col cols="10" class="py-8 py-md-0">
                <Scribbles />
                <router-link block text v-for="artist in artists" :key="artist.id" :to="{name: 'Artist', params: {slug: artist._slug}}" class="d-block justify-start py-3 py-md-2 py-lg-0 w-100">
                  <h1 class="text-sans d-block artist-item" :data-selected="selectedArtist && selectedArtist.id === artist.id">
                    <span class="normal">{{artist.name}}</span>
                    <span class="p-absolute text-script over w-100">{{artist.name}}</span>
                    <div class="p-absolute over-helper" @mouseenter="selectedArtist = artist" />
                  </h1>
                </router-link >

              <v-btn text small exact v-if="$root.prevRoute" :to="$root.prevRoute" key="genericback" class="text-script bottom-left-btn" data-cursor-target="back|center center">Back</v-btn>
              <!-- <v-btn text small v-if="PhotoExhibition" :to="{name: 'PhotoExhibition', params: {slug: PhotoExhibition._slug}}" class="bottom-left-btn text-script" data-cursor-target="back|center center">Back</v-btn> -->
            </v-col>
          </v-row>
        </MomentumScrolling>
      <!-- </ClipPageMask> -->
      <div class="artist-profile-holder" ref="profileHolder">
        <div class="p-absolute w-100 h-100 polaroid">
          <img ref="polaroid01" class="p-absolute" :src="polaroidImg">
          <img ref="polaroid02" class="p-absolute" :src="polaroidImg">
        </div>
        <div class="artist-profile">
          <transition mode="out-in">
          <v-img
            v-if="selectedArtist"
            class="p-absolute w-100 h-100"
            :key="selectedArtist.id"
            :src="optimizedImageURL(selectedArtist.thumbnail, {breakpointSize: $vuetify.breakpoint, quality: 90})"
            :lazy-src="getLazySrc(selectedArtist.thumbnail)"
            eager
            cover
          />
           </transition>
        </div>
        <img class="p-absolute tape" :src="tapeImg">
      </div>
    </v-row>
    <!-- loading -->
    <v-row v-else class="fill-height" align="center" justify="center" key="loading">
      <Scribbles />
      <v-col cols="auto" >
        <div class="animated-eye" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// eslint-disable-next-line
import gsap from 'gsap'
import reject from 'lodash/reject'
import { Viewport } from '@monogrid/vue-lib'
// import ClipPageMask from '@/molecules/ClipPageMask'
import Scribbles from '@/molecules/Scribbles'
import MomentumScrolling from '@/atoms/MomentumScrolling'
import polaroidImg from '@/assets/img/artists/polaroid.jpg'
import tapeImg from '@/assets/img/artists/tape.png'
import ListArtist from '@/graphql/ListArtist.gql'
import { optimizedImageURL, getLazySrc } from '@/services/OptimizedImage'

export default {
  name: 'PhotoExhibitionArtistsListPage',
  mixins: [Viewport],
  props: {
    slug: {
      required: true,
      type: String
    }
  },
  components: {
    Scribbles,
    MomentumScrolling
  },
  data () {
    return {
      scroll: 0,
      tapeImg,
      polaroidImg,
      transitionComplete: false,
      loaded: false,
      selectedArtist: null
    }
  },
  computed: {
    artists () {
      if (!this.Artists) return []
      return reject(this.Artists.items, { _referents: { SpecialProjectReferents: { totalCount: 0 } } })
    }
  },
  watch: {
    selectedArtist () {
      // console.log(this.selectedArtist)
      const { profileHolder } = this.$refs
      gsap.to(profileHolder, {
        duration: 20,
        rotation: 10 + this.getRandomArbitrary(-5, 5),
        ease: 'expo.out'
      })
    }
  },
  apollo: {
    Artists: {
      query: ListArtist,
      variables () {
        return {
          status: 'PUBLISHED',
          sortOn: '_slug',
          descending: false
        }
      },

      result () {
        this.$nextTick(this.doTransitionIn)
      }
    }
  },

  metaInfo () {
    if (this.PhotoExhibition) {
      return {
        // about page browser title
        title: `Artists | ${this.PhotoExhibition.title}`,
        meta: [
          { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: `Artists | ${this.PhotoExhibition.title} | PhotoVogue Festival 2020` }
        ]
      }
    }
  },

  methods: {
    optimizedImageURL,
    getLazySrc,
    getRandomArbitrary (min, max) {
      return Math.random() * (max - min) + min
    },

    getRandomInt (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },

    doTransitionIn () {
      this.loaded = true
      const $artists = this.$el.querySelectorAll('.artist-item')
      const { profileHolder } = this.$refs

      gsap.to($artists, {
        duration: 1,
        y: 0,
        autoAlpha: 1,
        ease: 'quint.out',
        stagger: 0.05
      })

      gsap.killTweensOf(profileHolder)
      gsap.to(profileHolder, {
        duration: 1.5,
        opacity: 1,
        ease: 'expo.inOut',
        onComplete: () => {
          this.transitionComplete = true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

  .artists-holder {
    max-width: 1440px;
    margin: 0 auto;
  }

  .artist-item {
    position: relative;
    white-space: normal;
    line-height: 1.15;
    font-size: 2.75rem;
    opacity: 0;
    transform: translateY(80px);
    // z-index: 2;

    @include breakpoint(md-and-up) {
      font-size: 3.5rem;
    }

    @include breakpoint(lg-and-up) {
      font-size: 5rem;
    }

    .over-helper {
      position: absolute;
      width: 100%;
      height: 50%;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    &[data-selected] {
      span {
        &.normal {
          opacity: 0.06;
        }

        &.over {
          top: 0;
          opacity: 1;
        }
      }
    }

    span {
      transition: opacity 1s 0s $ease-out-expo;
      pointer-events: none;

      &.over {
        left: 0;
        font-size: 1.5rem;
        color: #e00;
        opacity: 0;
        transition-duration: 2s;

        @include breakpoint(md-and-up) {
          font-size: 1.75rem;
        }

        @include breakpoint(lg-and-up) {
          font-size: 2.7rem;
          // top: 50%;
          // transform: translateY(-50%);
        }
      }
    }
  }

  .artist-profile-holder {
    pointer-events: none;
    display: none;
    position: fixed;
    width: 360px;
    height: 520px;
    left: 66%;
    top: 60%;
    transform: translate(-50%, -50%) rotate(10deg);
    opacity: 0;
    // z-index: 5;

    @include breakpoint(md-and-up) {
      display: block;
    }

    .tape {
      top: -36px;
      left: 50%;
      width: 120px;
      transform: translate(-50%, 0);
    }

    .polaroid {
      img {
        // scss
        width: 100%;
        height: auto;
        opacity: 0.85;

        &:nth-child(1) {
          top: 20%;
          left: -15%;
          transform: rotate(5deg);
        }

        &:nth-child(2) {
          top: -10%;
          left: 30%;
          transform: rotate(10deg);
        }
      }
    }
  }

  .artist-profile {
    position: absolute;
    width: 80%;
    height: 75%;
    left: 50%;
    top: 35%;
    transform: translate(-50%, -50%);
    border: 5px solid #fff;
    background-color: #eee;
  }

  ::v-deep .scrolling-content {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
</style>
